export default __webpack_public_path__ + "static/media/Group-146@2x.ac139852.png";